import { isMutualFundAccount, isMutualFundLegal } from "../../helpers/ProfileHelpers";
import { useSelector } from "react-redux";
import { accountTypeSelector } from "../../slices/profileSlice";

export const useCurrentAccount = () => {
  const accountType = useSelector(accountTypeSelector);

  return {
    accountType,
    isMutualFund: isMutualFundAccount(accountType),
    isMutualFundLegal: isMutualFundLegal(accountType),
    isNotIndividual: isMutualFundAccount(accountType) || isMutualFundLegal(accountType),
  };
};
